import React, { useState, useMemo } from 'react'
import { Skeleton } from 'antd'

import { PrescriptionDisplay } from './PrescriptionDisplay'
import { PrescriptionActionModal } from './PrescriptionActionModal'
import { PRESCRIPTION_ACTIONS } from '../../../constants'
import { usePrescribedTreatments } from '../../../hooks'
import { useCaseViewContext } from '../../../context'
import { useDispenseUnits } from '../../../hooks/useDispenseUnits'

export const PrescribedTreatments = ({ isAssignedProvider, isAdmin }) => {
    const { caseDetails, activeRequest, provider, apiClasses } = useCaseViewContext()
    if (!caseDetails || !caseDetails.patient) return null

    const { getDispenseUnitById } = useDispenseUnits({ apiClasses })
    
    const [prescriptionActionState, setPrescriptionActionState] = useState({
        selectedPrescription: null,
        action: null,
        handler: null
    })
    
    const {
        prescriptions,
        loading,
        handleCancelPrescription,
        handleDeletePrescription,
        handleResendPrescription
    } = usePrescribedTreatments({ 
        source: 'request',
        caseDetails, 
        activeRequest, 
        apiClasses 
    })
    
    const providerId = provider?.userId || provider?.userEmail || provider?._id
    const assignedProviderId = caseDetails?.assignedPhysician || caseDetails?.assignedProvider || caseDetails?.physicianId || caseDetails?.physicianEmail
    
    const actualIsAssignedProvider = isAssignedProvider !== undefined ? isAssignedProvider : (providerId === assignedProviderId)
    
    const setPrescriptionAndAction = ({ prescription, action }) => {
        
        const prescriptionActionHandlers = {
            [PRESCRIPTION_ACTIONS.CANCEL]: handleCancelPrescription,
            [PRESCRIPTION_ACTIONS.RESEND]: handleResendPrescription,
            [PRESCRIPTION_ACTIONS.DELETE]: handleDeletePrescription
        }

        if (!prescriptionActionHandlers[action]) {
            return console.error('Action not supported:', action)
        }

        setPrescriptionActionState({
            action,
            handler: prescriptionActionHandlers[action],
            selectedPrescription: prescription
        })
        
    }

    const deselectRx = () => {
        setPrescriptionActionState({
            selectedPrescription: null,
            action: null,
            handler: null
        })
    }
    
    return (
        <Skeleton loading={loading} active paragraph={{ rows: 3 }}>
            {!prescriptions || prescriptions.length === 0 ? (
                <div>
                    <p>No Prescribed Medications</p>
                </div>
            ) : (
                (prescriptions || [])
                    .sort((a, b) => new Date(b.signedAt) - new Date(a.signedAt))
                    .map(prescription => (
                           <PrescriptionDisplay
                               key={prescription.prescriptionId}
                               prescription={prescription}
                               isAssignedProvider={actualIsAssignedProvider}
                               isAdmin={isAdmin}
                               getDispenseUnitById={getDispenseUnitById}
                               setPrescriptionAndAction={setPrescriptionAndAction}
                           />
                    ))
            )}
            
            {prescriptionActionState.selectedPrescription && 
             prescriptionActionState.action && 
             prescriptionActionState.handler && 
             provider && (
                <>
                    <PrescriptionActionModal
                        prescription={prescriptionActionState.selectedPrescription}
                        action={prescriptionActionState.action}
                        handler={prescriptionActionState.handler}
                        provider={provider}
                        deselectRx={deselectRx}
                        isAdmin={isAdmin}
                    />
                </>
            )}
        </Skeleton>
    )
}
